import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
var handler = void 0;
var mathjsFactory = void 0;
var mathjs = {
  create: function create() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var container = {
      initFlag: false,

      fns: [],

      mathjs: undefined
    };
    mathjsFactory.create(args).then(function (mathjs) {
      container.mathjs = mathjs;
      container.fns.forEach(function (_ref) {
        var fn = _ref.fn,
            args = _ref.args;

        if (typeof mathjs[fn] === 'function') mathjs[fn].apply(mathjs, args);
      });
      container.initFlag = true;
    });
    return new Proxy(container, handler);
  }
};

handler = {
  get: function get(target, key) {
    if (!target.initFlag) {
      return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        target.fns.push({
          fn: key,
          args: args
        });
      };
    } else {
      if (key in target.mathjs) {
        return target.mathjs[key];
      } else {
        return undefined;
      }
    }
  }
};

mathjsFactory = {
  _mathjs: undefined,
  create: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(args) {
      var _this = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this._mathjs) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", import("mathjs").then(function (mathjs) {
                _this._mathjs = mathjs;
                console.log("_mathjs", _this._mathjs);
                return _this._mathjs.create.apply(undefined, [_this._mathjs.all]);
              }));

            case 2:
              return _context.abrupt("return", this._mathjs.create.apply(undefined, [this._mathjs.all]));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _ref2.apply(this, arguments);
    }

    return create;
  }()
};

export default mathjs;


//////////////////
// WEBPACK FOOTER
// ./src/tools/mathjsLib.js
// module id = 850
// module chunks = 2